import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { UtilService } from '../../services/util.service';
import { AppService } from '../../shared/services/app.service';
import { DialogRef } from '../dialog/dialog-ref';
import { FormBuilder } from '@angular/forms';
import { DialogConfig } from '../dialog/dialog-config';
import { debounceTime, filter, fromEvent } from 'rxjs';
declare var webkitSpeechRecognition: any;

@Component({
  selector: 'app-text-to-speech',
  templateUrl: './text-to-speech.component.html',
  styleUrls: ['./text-to-speech.component.scss'],
  standalone: false
})
export class TextToSpeechComponent implements OnInit, OnDestroy {
  speech: boolean = true; resourceName: string = "This feature "; finalTranscript: any = "";
  showMicroPhonePopUp: boolean = false; device: any = "microphone"; speakort: string = "speakort";
  recognition: any; transcript: any = ""; closingTime: any = 8; speechCloseTimer: any;
  @ViewChild('myTextarea') myTextarea: any; play: boolean = true;
  speechText: string = ''; changeColor: boolean = true; accuracy: any = 0; searchElement: boolean = false;


  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig,
    private appService: AppService,
    private util: UtilService,
    private alert: AlertsService,
    private cdRef: ChangeDetectorRef
  ) {
    // this.recognition = new webkitSpeechRecognition();
    if (typeof webkitSpeechRecognition !== 'undefined') {
      this.recognition = new webkitSpeechRecognition();
    } else if (typeof (window as any).SpeechRecognition !== 'undefined') {
      this.recognition = new (window as any).SpeechRecognition();
    } else {
      this.speech = false; // not supported
    }
    fromEvent<KeyboardEvent>(document, 'keydown')
      .pipe(
        filter((e: any) => e.code === 'Space'),
        debounceTime(200)
      )
      .subscribe(() => {
        // console.log('Space triggered');
        this.playPause();
      });
  }



  resetIntervalSpeech() {
    if (this.speechCloseTimer) {
      clearInterval(this.speechCloseTimer);
    }

    this.closingTime = 8;
    if (!this.play) {
      this.closingTime = 9999999999999;
    }

    this.speechCloseTimer = setInterval(() => {
      this.closingTime -= 1;

      if (this.closingTime <= 0) {
        clearInterval(this.speechCloseTimer);
        this.close();
      }
    }, 1000); // 1 second countdown
  }

  closedevicePopup(event: any) {
    this.close()
  }

  // autoResize(textarea: HTMLTextAreaElement) {
  //   textarea.style.height = 'auto'; // reset height
  //   textarea.style.height = textarea.scrollHeight + 'px'; // set to content height
  // }


  checkMicroPhone$() {
    var _that = this;
    if (this.util.isIphone() && this.appService.checkNativeApp()) {
      this.showSpeechMicrophone$();
      return;
    }
    this.util.detectMicroPhone((res: any) => {
      if (res) {
        this.checkAudioPermission((result: any) => {
          if (result == "prompt") {
            // this.closePopup()
            _that.util.checkAudioAccessStatus()
            _that.showMicroPhonePopUp = true;
            _that.device = "microphone"
          } else if (result == "denied") {
            // this.closePopup();
            _that.util.checkAudioAccessStatus()
            _that.device = "microphone"
            _that.showMicroPhonePopUp = true;
          } else {
            this.showSpeechMicrophone$()
          }
        })
      } else {
        this.alert.error("No microphone detected");
        this.close()
      }
    })
  }

  ngOnInit(): void {
    this.searchElement = this.dialogConfig.data?.searchElement || false;
    this.checkMicroPhone$()
  }

  // showSpeechMicrophone$() {
  //   if (!this.speech) {
  //     this.alert.error("Speech to text is not supported in this browser");
  //     this.close();
  //     return;
  //   }

  //   this.recognition.interimResults = true;
  //   this.recognition.isActive = true;
  //   this.recognition.lang = 'en-IN';
  //   if (!this.searchElement) {
  //     this.resetIntervalSpeech();
  //   }
  //   this.recognition.addEventListener('result', e => {
  //     if (!this.play) {
  //       return;
  //     }
  //     let interimTranscript = '';

  //     for (let i = e.resultIndex; i < e.results.length; i++) {
  //       let chunk = e.results[i][0].transcript;

  //       const grammarMap = this.checkgrammer();
  //       for (const [word, symbol] of Object.entries(grammarMap)) {
  //         const regex = new RegExp(`\\b${word}\\b`, 'gi');
  //         chunk = chunk.replace(regex, symbol);
  //       }
  //       if (/^(\d+ )*(\d+)$/.test(chunk)) {
  //         chunk = chunk.replace(/ /g, '');
  //       }
  //       this.accuracy = 0;
  //       if (e.results[i].isFinal) {
  //         this.accuracy = e.results[i][0] && e.results[i][0].confidence === 0 ? 100 : Math.round(e.results[i][0].confidence * 100).toFixed(2);
  //         this.finalTranscript = (this.finalTranscript ? this.finalTranscript : "") + chunk + ' ';
  //       } else {
  //         this.accuracy = e.results[i][0] && e.results[i][0].confidence === 0 ? 100 : Math.round(e.results[i][0].confidence * 100).toFixed(2);
  //         this.changeColor = false;
  //         interimTranscript = (interimTranscript ? interimTranscript : "") + chunk;
  //       }
  //     }
  //     const fullText = (this.finalTranscript + interimTranscript).trim();
  //     this.speechText = fullText;
  //     this.cdRef.detectChanges();
  //     this.autoResize();
  //     if (!this.searchElement) {
  //       this.resetIntervalSpeech();
  //     }
  //   });
  //   this.recognition.addEventListener('end', () => {
  //     this.changeColor = true;
  //     this.accuracy = 0;
  //     if (this.speech && !this.searchElement) {
  //       this.recognition.start();
  //     } else if (this.searchElement) {
  //       this.close();
  //     }
  //   });
  //   this.recognition.start();
  // }

  close() {
    if (this.speechText == 'close')
      this.speechText = ""
    this.dialogRef.close();
  }

  playPause() {
    this.play = !this.play;
    if (!this.play) {
      this.resetIntervalSpeech();
    }
    if (this.util.isIphone() && this.appService.checkNativeApp() && this.play) {
      this.startFlutterNativeSpeech()
    }
  }

  checkAudioPermission(callback) {
    if (this.appService.checkNativeApp() || this.util.isiOS()) {
      if (!this.appService.checkNativeApp() && this.util.isMac()) {
        callback("granted");
        return;
      }
      // navigator.mediaDevices.getUserMedia({ audio: true })
      //   .then((stream) => {
      //     stream.getTracks().forEach(track => track.stop());
      //     callback("granted");
      //   })
      //   .catch((err) => {
      //     console.error('Mic permission denied:', err);
      //     callback("denied");
      //   });
      callback("granted");
      return;
    } else {
      const permissionName = "microphone" as PermissionName;
      navigator.permissions.query({ name: permissionName }).then(function (permissionStatus) {
        if (permissionStatus.state == 'prompt' || permissionStatus.state == 'denied') {
          callback(permissionStatus.state);
        } else {
          callback(permissionStatus.state);
        }
      });
    }
  }

  showSpeechMicrophone$() {
    // ✅ iOS in native app — use Flutter native speech bridge
    if (this.util.isIphone() && this.appService.checkNativeApp()) {
      this.startFlutterNativeSpeech();
      return;
    }

    if (!this.speech) {
      this.alert.error("Speech to text is not supported in this browser");
      this.close();
      return;
    }

    this.startRecognition();
  }

  startFlutterNativeSpeech() {
    if (!this.searchElement) {
      this.resetIntervalSpeech();
    }

    // ✅ Remove old listeners to avoid duplicates
    window.removeEventListener('flutterSpeechResult', this.onFlutterSpeechResult);
    window.addEventListener('flutterSpeechResult', this.onFlutterSpeechResult.bind(this));

    // ✅ Call Flutter handler
    (window as any).flutter_inappwebview
      .callHandler('startSpeechRecognition', { lang: 'en-IN' });
  }

  onFlutterSpeechResult = (event: any) => {
    const detail = event.detail;
    if (detail.error) {
      //this.alert.error("Error in speech recognition");
      this.close();
      return;
    }
    if (detail.transcript) {
      let chunk = detail.transcript;
      const grammarMap = this.checkgrammer();
      for (const [word, symbol] of Object.entries(grammarMap)) {
        const regex = new RegExp(`\\b${word}\\b`, 'gi');
        chunk = chunk.replace(regex, symbol);
      }
      if (/^(\d+ )*(\d+)$/.test(chunk)) {
        chunk = chunk.replace(/ /g, '');
      }
      this.speechText = chunk;
      this.finalTranscript = chunk;
      this.cdRef.detectChanges();
      this.autoResize();
      if (!this.searchElement) {
        this.resetIntervalSpeech();
      }
    }
  }

  startRecognition() {
    this.recognition.interimResults = true;
    this.recognition.isActive = true;
    this.recognition.lang = 'en-IN';
    if (!this.searchElement) {
      this.resetIntervalSpeech();
    }
    this.recognition.addEventListener('result', e => {
      if (!this.play) return;
      let interimTranscript = '';
      for (let i = e.resultIndex; i < e.results.length; i++) {
        let chunk = e.results[i][0].transcript;
        const grammarMap = this.checkgrammer();
        for (const [word, symbol] of Object.entries(grammarMap)) {
          const regex = new RegExp(`\\b${word}\\b`, 'gi');
          chunk = chunk.replace(regex, symbol);
        }
        if (/^(\d+ )*(\d+)$/.test(chunk)) {
          chunk = chunk.replace(/ /g, '');
        }
        this.accuracy = 0;
        if (e.results[i].isFinal) {
          this.accuracy = e.results[i][0] && e.results[i][0].confidence === 0 ? 100 : Math.round(e.results[i][0].confidence * 100).toFixed(2);
          this.finalTranscript = (this.finalTranscript ? this.finalTranscript : "") + chunk + ' ';
        } else {
          this.accuracy = e.results[i][0] && e.results[i][0].confidence === 0 ? 100 : Math.round(e.results[i][0].confidence * 100).toFixed(2);
          this.changeColor = false;
          interimTranscript = (interimTranscript ? interimTranscript : "") + chunk;
        }
      }
      const fullText = (this.finalTranscript + interimTranscript).trim();
      this.speechText = fullText;
      this.cdRef.detectChanges();
      this.autoResize();
      if (!this.searchElement) this.resetIntervalSpeech();
    });
    this.recognition.addEventListener('end', () => {
      this.changeColor = true;
      this.accuracy = 0;
      if (this.speech && !this.searchElement) {
        this.recognition.start();
      } else if (this.searchElement) {
        this.close();
      }
    });
    this.recognition.start();
  }

  ngOnDestroy() {
    window.removeEventListener('flutterSpeechResult', this.onFlutterSpeechResult);
    if (this.util.isiOS() && this.appService.checkNativeApp()) {
      (window as any).flutter_inappwebview
        .callHandler('stopSpeechRecognition');
    } else {
      this.recognition?.stop();
      this.recognition.isActive = false;
    }
    this.speech = false;
    this.dialogRef.close(this.speechText ? this.speechText : "");
  }

  // showSpeechMicrophone$() {
  //   if (!this.speech) {
  //     this.alert.error("Speech to text is not supported in this browser");
  //     this.close();
  //     return;
  //   }

  //   // ✅ ADD THIS: Check if iOS native app — use getUserMedia instead
  //   if (this.util.isiOS() && this.appService.checkNativeApp()) {
  //     navigator.mediaDevices.getUserMedia({ audio: true })
  //       .then((stream) => {
  //         // Permission granted — now start recognition
  //         stream.getTracks().forEach(track => track.stop()); // release stream
  //         this.startRecognition();
  //       })
  //       .catch((err) => {
  //         console.error('Mic permission denied:', err);
  //         this.alert.error("Please allow microphone access in Settings");
  //         this.close();
  //       });
  //     return;
  //   }

  //   this.startRecognition();
  // }

  // // ✅ Extract recognition logic into separate method
  // startRecognition() {
  //   this.recognition.interimResults = true;
  //   this.recognition.isActive = true;
  //   this.recognition.lang = 'en-IN';
  //   if (!this.searchElement) {
  //     this.resetIntervalSpeech();
  //   }
  //   this.recognition.addEventListener('result', e => {
  //     // ... your existing result handler
  //   });
  //   this.recognition.addEventListener('end', () => {
  //     this.changeColor = true;
  //     this.accuracy = 0;
  //     if (this.speech && !this.searchElement) {
  //       this.recognition.start();
  //     } else if (this.searchElement) {
  //       this.close();
  //     }
  //   });
  //   this.recognition.start();
  // }

  // checkAudioPermission(callback) {
  //   var that = this;
  //   if (this.appService.checkNativeApp() || this.util.isiOS()) {
  //     // callback(true);
  //     navigator.mediaDevices.getUserMedia({ audio: true })
  //       .then((stream) => {
  //         stream.getTracks().forEach(track => track.stop());
  //         callback("granted");
  //       })
  //       .catch((err) => {
  //         console.error('Mic permission denied:', err);
  //         this.alert.error("Please allow microphone access in Settings");
  //         // this.close();
  //       });
  //     return;
  //   } else {
  //     const permissionName = "microphone" as PermissionName;
  //     navigator.permissions.query({ name: permissionName }).then(function (permissionStatus) {
  //       if (permissionStatus.state == 'prompt' || permissionStatus.state == 'denied') {
  //         that.alert.error("Please give permission to access microphone");
  //         callback(permissionStatus.state)
  //       } else {
  //         callback(permissionStatus.state);
  //       }
  //     })
  //   }
  // }

  // ngOnDestroy() {
  //   this.recognition.stop();
  //   this.recognition.isActive = false;
  //   this.speech = false;
  //   this.dialogRef.close(this.speechText ? this.speechText : "");
  // }

  mannualWritting() {
    this.closingTime = 8;
    this.finalTranscript = this.speechText;
  }

  autoResize() {
    if (this.myTextarea.nativeElement.scrollHeight > this.myTextarea.nativeElement.clientHeight) {
      this.myTextarea.nativeElement.style.height = 'auto'; // reset height
      this.myTextarea.nativeElement.style.height = this.myTextarea.nativeElement.scrollHeight + 'px'; // set to content height
    }

  }

  checkgrammer() {
    let v = {
      "underscore": "_", "forward slash": "/", "hyphen": "-", "colon": ":", "semicolum": ";", "semicolumn": ";", "semicolon": ";", "dot": "."
      , "question mark": "?", "slash": "/", "full stop": ".", "comma": ",", "quote": "'", "double quote": '"',
      "single quote": "'", "dash": "-", "enter": "\n", "new line": "\n", "newline": "\n", "double quotes": '"', "next line": "\n", "click space bar": "Play/ Pause"
    };
    return v;
  }

  replceKeyWords(key): any {
    let v = {
      "enter": "New Line", "new line": "Next Line", "newline": "Next Line", "next line": "Next Line", "double quotes": "Double Quotes",
    };
    return v[key] || false;
  }

  // checkLength() {
  //   return Array.from({ length: 3 }, (_, i) => i * 3);
  // }

}